import React from "react";
import { Box } from "@mui/material";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";

const isTruthy = (v) =>
  v === true ||
  v === "true" ||
  v === "Y" ||
  v === "yes" ||
  v === 1;

const AdminBoolCell = ({ value }) => {
  const on = isTruthy(value);
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "50%",
        backgroundColor: on ? "#dcfce7" : "transparent",
        flexShrink: 0,
        mx: "auto",
      }}
    >
      {on ? (
        <Check
          sx={{ color: "#166534", fontSize: 18, display: "block" }}
          aria-label="Yes"
        />
      ) : (
        <Close
          sx={{ color: "#94a3b8", fontSize: 16, display: "block" }}
          aria-label="No"
        />
      )}
    </Box>
  );
};

export default AdminBoolCell;
